import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Typography } from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { formStyles } from '../ClaimCMS1500Form.styles';
import { ClaimTextField } from '../fields';

interface Box28Props {
  formatCurrencyForDisplay: (value: string | number) => string;
}

export const Box28_TotalCharge: React.FC<Box28Props> = ({ formatCurrencyForDisplay }) => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Typography variant="caption">28. TOTAL CHARGE</Typography>
      <Controller
        name="totalCharge"
        control={control}
        render={({ field, fieldState }) => (
          <ClaimTextField
            field={{
              ...field,
              value: formatCurrencyForDisplay(field.value || '0'),
            }}
            fieldState={fieldState}
            size="small"
            fullWidth
            placeholder="0.00"
            sx={formStyles.amountField}
            InputProps={{
              readOnly: true,
            }}
            helperText={fieldState.error?.message || "Sum of all service line charges"}
          />
        )}
      />
    </>
  );
};